// src/components/LoginButton.jsx
import React, { useEffect, useState } from 'react';
import { auth, provider } from '../../Logica/firebase/firebase.js';
import { signInWithPopup } from 'firebase/auth';

// OJO: esta ventana es solo la del front (controla si se muestra el botón).
// La que realmente cuenta es la del backend (api/index.js, /login), que usa
// el reloj del servidor y es la que no se puede burlar cambiando la hora de
// la compu. Deben quedar iguales. Esta es la ventana de PRUEBA de esta noche;
// para producción cambiar a la real (ej. 2026-08-06T08:30:00-06:00 a
// 2026-08-06T17:00:00-06:00) en ambos lados.
const FECHA_INICIO_REGISTRO = new Date('2026-08-06T08:30:00-06:00');
const FECHA_CIERRE_REGISTRO = new Date('2026-08-06T19:00:00-06:00');

function formatearHora(fecha) {
  return fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
}

const DIAS_SEMANA = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

const HORA_INICIO_TEXTO = formatearHora(FECHA_INICIO_REGISTRO);
const HORA_CIERRE_TEXTO = formatearHora(FECHA_CIERRE_REGISTRO);
const FECHA_TEXTO = `${DIAS_SEMANA[FECHA_INICIO_REGISTRO.getDay()]} ${FECHA_INICIO_REGISTRO.getDate()} de ${MESES[FECHA_INICIO_REGISTRO.getMonth()]}`;

function calcularTiempoRestante() {
  const diferencia = FECHA_INICIO_REGISTRO.getTime() - Date.now();
  if (diferencia <= 0) {
    return { dias: 0, horas: 0, minutos: 0, segundos: 0, terminado: true };
  }

  const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
  const horas = Math.floor((diferencia / (1000 * 60 * 60)) % 24);
  const minutos = Math.floor((diferencia / (1000 * 60)) % 60);
  const segundos = Math.floor((diferencia / 1000) % 60);

  return { dias, horas, minutos, segundos, terminado: false };
}

const LoginButton = () => {
  const [tiempoRestante, setTiempoRestante] = useState(calcularTiempoRestante);
  // Se recalcula cada segundo junto con tiempoRestante, para que abra/cierre
  // solo sin necesidad de recargar la página.
  const [ahora, setAhora] = useState(Date.now());

  useEffect(() => {
    const intervalo = setInterval(() => {
      setTiempoRestante(calcularTiempoRestante());
      setAhora(Date.now());
    }, 1000);
    return () => clearInterval(intervalo);
  }, []);

  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Error al iniciar tu registro:", error);
    }
  };

  const yaAbrio = ahora >= FECHA_INICIO_REGISTRO.getTime();
  const yaCerro = ahora >= FECHA_CIERRE_REGISTRO.getTime();

  return (
    <>
      {!yaAbrio && (
        <div className="alert alert-primary text-center" role="alert">
          <h5 className="mb-1">🔵 La inscripción se abrirá el día {FECHA_TEXTO} de {HORA_INICIO_TEXTO} a {HORA_CIERRE_TEXTO} horas 🔵</h5>
          <div>
            Faltan {String(tiempoRestante.dias).padStart(2, '0')}d{' '}
            {String(tiempoRestante.horas).padStart(2, '0')}:
            {String(tiempoRestante.minutos).padStart(2, '0')}:
            {String(tiempoRestante.segundos).padStart(2, '0')}
          </div>
        </div>
      )}

      {yaAbrio && !yaCerro && (
        <button onClick={handleLogin} className="btn btn-primary">
          Iniciar con credenciales institucionales.
        </button>
      )}

      {yaCerro && (
        <div className="alert alert-danger text-center" role="alert">
          🔴 La inscripción ha finalizado, para mayor información comunícate a los correos{' '}
          <a href="mailto:aportill@tec.mx">aportill@tec.mx</a> o{' '}
          <a href="mailto:aatorres@tec.mx">aatorres@tec.mx</a> 🔴
        </div>
      )}
    </>
  );
};

export default LoginButton;
